import React from "react";

export default function Footer() {
  return (
    <div className="pb-3">
      <p>
        <span className="text-[#acaaaa] text-xs">
          By continuing, you agree to Lona's and
        </span>{" "}
        <span className="text-xs underline">Privacy Policy</span>.
      </p>
    </div>
  );
}
